export default {
    data: () => ({
        lendingKitPendingReceptionColumnsMobile: [
            {
                label: "start date",
                field: "start_lending_at",
                required: true,
                type: 'date'
            },
            {
                label: "kit stock status",
                field: "stock_status.description",
                required: true,
                sortable: true
            }, {
                label: "model",
                field: "product_model.description",
                sortable: true,
                required: true
            }, {
                label: "color",
                field: "product_color.description",
                sortable: true,
                required: true
            },
            {
                label: "codentify",
                field: "codentify",
                sortable: true,
                required: true,
                collapsibleLabel: true
            }, {
                label: "lending point",
                field: "lending_point.description",
                required: true
            }, {
                label: "child codentify 1",
                field: "child_codentify_1",
                sortable: true
            }, {
                label: "child codentify 2",
                field: "child_codentify_2",
                sortable: true
            },
            {
                label: "lendings",
                field: "uses",
                sortable: true
            },
            {
                label: "enable lending creation",
                field: "enable_to_creation",
                sortable: true
            },
        ],
        lendingKitTabFilters: window.config.stockStatuses
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lendingKitPendingReceptionColumnsMobile.js